import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { DataService } from '../data-service/data-service.service';

@Injectable({
  providedIn: 'root'
})

export class HttpService {

  token: any;
  headers = new Headers();

  constructor(private http: Http, private service: DataService) {
    let cred = JSON.parse(localStorage.getItem('cred'))
    console.log(cred)
    if (cred != null && cred != undefined) {
      this.token = cred.token;
      this.headers.append('Content-Type', 'application/json');
      this.headers.append("x-access-token", this.token);
    }
  }

  hostUrl: string = this.service.ipaddr;

  createAuthorizationHeader() {
    console.log(this.token);
  }

  get(url) {
    console.log(this.hostUrl + url)
    let header = new Headers();
    let cred = JSON.parse(localStorage.getItem('cred'))
    this.token = cred.token;
    // console.log(this.token)
    header.append('Content-Type', 'application/json');
    header.append("x-access-token", this.token);
    // console.log(this.headers);
    return this.http.get(this.hostUrl + url, {
      headers: header
    });
  }

  post(url, data) {
    let header = new Headers();
    let cred = JSON.parse(localStorage.getItem('cred'))
    this.token = cred.token;
    // console.log(this.token)
    header.append('Content-Type', 'application/json');
    header.append("x-access-token", this.token);
    // console.log(header);
    return this.http.post(this.hostUrl + url, data, {
      headers: header
    });
  }

  postImage(url, data) {
    return this.http.post(this.hostUrl + url, data);
  }

  put(url, data) {
    let header = new Headers();
    let cred = JSON.parse(localStorage.getItem('cred'))
    this.token = cred.token;
    // console.log(this.token)
    header.append('Content-Type', 'application/json');
    header.append("x-access-token", this.token);
    // console.log(header);
    return this.http.post(this.hostUrl + url, data, {
      headers: header
    });
  }

  delete(url) {
    let header = new Headers();
    let cred = JSON.parse(localStorage.getItem('cred'))
    this.token = cred.token;
    // console.log(this.token)
    header.append('Content-Type', 'application/json');
    header.append("x-access-token", this.token);
    // console.log(header);
    return this.http.delete(this.hostUrl + url, {
      headers: header
    });
  }
}
